'use client';
import { shopServiceType } from '@/commonTypes';
import { PageHero } from '@/components/general/PageHero';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React, { useEffect } from 'react';
import ServiceShopHero from './ServiceShopHero';
import { useLayoutContext } from '@/context/LayoutContext';
import ServiceShopBody from './ServiceShopBody';
import { mockService } from '@/mock/sample.json';

interface PageProps {
  data?: shopServiceType;
}

export default function SingleShopServiceContent({ data }: PageProps) {
  const { editInfo, setEditInfo } = useLayoutContext();
  const sample: shopServiceType = mockService;

  // useEffect(() => {
  //   setEditInfo({ item: data, level: 1 });
  // }, [data]);
  useEffect(() => {
    setEditInfo({ item: sample, level: 2, type: 'service' });
  }, []);
  console.log('editInfo==', editInfo);
  return (
    <>
      <PageWrapper className={`p-0 section-light`}>
        <ViewportWrapper className={`pb-0 w-full `}>
          <ServiceShopHero data={sample} />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`p-0 section-light m-0 py-24px`}>
        <ViewportWrapper className={`pb-0 container `}>
          <ServiceShopBody data={sample} />
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
